import { Box2d } from '@tldraw/tldraw'

export const Outline = ({ bounds }: { bounds: Box2d }) => {
  return (
    <svg className="tl-overlays__item">
      <rect x={bounds.x} y={bounds.y} width={bounds.w} height={bounds.h} fill="none" stroke="red" strokeWidth="2" />
    </svg>
  )
}
